import { render } from "./InteractScreen.vue?vue&type=template&id=2839de20&scoped=true"
import script from "./InteractScreen.vue?vue&type=script&lang=js"
export * from "./InteractScreen.vue?vue&type=script&lang=js"

import "./InteractScreen.vue?vue&type=style&index=0&id=2839de20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2839de20"]])

export default __exports__